import { useDocumentLocale } from "../lib/microcopy";
import type { EconicLang, Localised } from "./types";

/** The language a primitive renders in: the `lang` prop when given, otherwise the document's (<html lang>). */
export function useEconicLang(lang?: EconicLang): EconicLang {
  const doc = useDocumentLocale();
  return lang ?? (doc === "ar" ? "ar" : "en");
}

export const pick = (text: Localised, lang: EconicLang): string => (lang === "ar" ? text.ar : text.en);
/** The other language's text, for the bilingual pairs ("Restricted · مقيد"). */
export const other = (text: Localised, lang: EconicLang): string => (lang === "ar" ? text.en : text.ar);

export function cx(...parts: (string | false | null | undefined)[]): string {
  return parts.filter(Boolean).join(" ");
}
